module.exports = __webpack_public_path__ + "humans.txt";


//////////////////
// WEBPACK FOOTER
// ./src/static/humans.txt
// module id = 18
// module chunks = 0